/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthW
 */
export interface AuthW {
    /**
     * Username
     * @type {string}
     * @memberof AuthW
     */
    username: string;
}

/**
 * Check if a given object implements the AuthW interface.
 */
export function instanceOfAuthW(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;

    return isInstance;
}

export function AuthWFromJSON(json: any): AuthW {
    return AuthWFromJSONTyped(json, false);
}

export function AuthWFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthW {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
    };
}

export function AuthWToJSON(value?: AuthW | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
    };
}

